import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Provider } from 'react-redux';
import store from './store/store';
import App from './App';
import { commonActions } from './actions/commonActions';
import { isIE } from './shared/scripts';

if (isIE() === true) {
  window.location = '/unsupported-browser.html';
}

store.dispatch(commonActions.checkSession());

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

export const router = createBrowserRouter([
  {
    path: "/*",
    element: <App />,
  }
]);

root.render(
  <Provider store={store}>
    <RouterProvider router={router}>
      <App />
    </RouterProvider>
  </Provider>
);